import React, { useState } from 'react';
import TabsComponent from '../../../components/Tabs/Tabs';
import classes from './Economics.module.css';
import Overview from '../../Reusables/Economics/Overview';
import { useQueryParamWithDefault } from '../../../hooks';
// External library imports
import { NumberParam } from 'use-query-params';

const Economics = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);

    const tabs = [
        {
            name: 'Overview',
            component: <Overview cId={cId} />,
            tabId: 1,
        },
    ];
    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default Economics;
